import { Equal } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgEquals = mkIcon(Equal);